// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.report-screen {
  margin-top: -2.5%; }
  .report-screen .title-container {
    margin-top: 2rem;
    position: absolute;
    top: 87px;
    z-index: 1;
    left: 100px;
    color: #fff; }
  .report-screen .smaller-title {
    top: 90px; }
    .report-screen .smaller-title h1 {
      font-size: calc(.8rem + 1.5vw); }
  .report-screen p {
    margin: unset;
    padding: unset; }
  .report-screen h1 {
    display: inline;
    margin-right: 10px; }
  .report-screen .layers-filters {
    display: inline; }
    .report-screen .layers-filters .tag {
      background-color: #4fc2d9;
      text-align: center;
      width: unset;
      display: inline;
      padding-right: 20px;
      padding-left: 10px;
      margin-right: 10px; }
      .report-screen .layers-filters .tag img#btn-remove {
        position: relative;
        left: 10px;
        top: -2px;
        cursor: pointer; }

.rounded-pill {
  cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/shared/report-title.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EACC,iBAAiB,EAAA;EADlB;IAGE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WDVqB,EAAA;ECEvB;IAYE,SAAS,EAAA;IAZX;MAcG,8BAA8B,EAAA;EAdjC;IAmBE,aAAa;IACb,cAAc,EAAA;EApBhB;IAwBE,eAAe;IACf,kBAAkB,EAAA;EAzBpB;IA+BE,eAAe,EAAA;IA/BjB;MAkCG,yBDnCyB;MCoCzB,kBAAkB;MAClB,YAAY;MACZ,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,kBAAkB,EAAA;MAxCrB;QA2CO,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,eAAe,EAAA;;AAMtB;EACC,eAAe,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import '../../../theme/_variables.scss';\n\n.report-screen{\n\tmargin-top: -2.5%;\n\t.title-container {\n\t\tmargin-top: 2rem;\n\t\tposition: absolute;\n\t\ttop: 87px;\n\t\tz-index: 1;\n\t\tleft: 100px;\n\t\tcolor: $primaryFontColor;\n\t}\n\n\t.smaller-title {\n\t\ttop: 90px;\n\t\th1 {\n\t\t\tfont-size: calc(.8rem + 1.5vw);\n\t\t}\n\t}\n\n\tp{\n\t\tmargin: unset;\n\t\tpadding: unset;\n\t}\n\n\th1{\n\t\tdisplay: inline;\n\t\tmargin-right: 10px;\n\t}\n\n\n\n\t.layers-filters{\n\t\tdisplay: inline;\n\n\t\t.tag{\n\t\t\tbackground-color: $secundaryFontColor;\n\t\t\ttext-align: center;\n\t\t\twidth: unset;\n\t\t\tdisplay: inline;\n\t\t\tpadding-right: 20px;\n\t\t\tpadding-left: 10px;\n\t\t\tmargin-right: 10px;\n\n\t\t\timg#btn-remove{\n\t\t\t    position: relative;\n\t\t\t    left: 10px;\n\t\t\t    top: -2px;\n\t\t\t    cursor: pointer;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.rounded-pill {\n\tcursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
